import { Flex, Loader, Text } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useMemo } from 'react'
import { fetchOrders } from '@/entities/order/api'
import { sortOrderDetailsByArrivalTime } from '@/entities/order/lib'
import { orderKeys, useRawOrdersQuery } from '@/entities/order/model'
import { getHistoryOrders } from '@/features/order/lib'
import { HistoryOrderCard } from '@/features/order/ui/history-order-card'
import { filterRawOrdersBySearch } from '@/features/search/lib'
import { useSearchStore } from '@/features/search/model'
import { OrderCardsGrid } from '@/widgets/order-cards-grid'

export const Route = createFileRoute('/_dashboard/dashboard/history')({
  component: HistoryComponent,
  loader: ({ context: { queryClient } }) => {
    queryClient.prefetchQuery({
      queryKey: orderKeys.orders(),
      queryFn: fetchOrders,
    })
  },
  pendingComponent: () => (
    <Flex direction="column" align="center" justify="center" style={{ flex: 1, minHeight: 300 }}>
      <Loader size="xl" />
      <Text mt="md">Loading order history...</Text>
    </Flex>
  ),
  errorComponent: error => (
    <Flex direction="column" align="center" justify="center">
      <Text c="red">
        Error:
        {' '}
        {error instanceof Error ? error.message : 'An unexpected error occurred while loading order history.'}
      </Text>
    </Flex>
  ),
})

function HistoryComponent() {
  const { data: orders } = useRawOrdersQuery()
  const { searchQuery, clearSearch } = useSearchStore()

  useEffect(() => {
    clearSearch()
  }, [clearSearch])

  const historyOrders = useMemo(() => {
    const baseHistoryOrders = getHistoryOrders(orders)
    const filtered = filterRawOrdersBySearch(baseHistoryOrders, searchQuery)
    return sortOrderDetailsByArrivalTime(filtered, 'desc')
  }, [orders, searchQuery])

  return (
    <OrderCardsGrid
      orders={historyOrders}
      title="History"
      emptyMessage="No history orders found"
      renderCard={order => (
        <HistoryOrderCard
          key={order.orderId}
          order={order}
        />
      )}
    />
  )
}
